// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_HE0","cls2":"CoScientistPricingPage-cls2_qeJ CoScientistPricingPage-cls1_HE0"};